"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactPopper = require("react-popper");
var _modifiers = require("./modifiers");
var _Context = require("../Context");
var _Portal = _interopRequireDefault(require("../../../components/Portal"));
var _ClickOutside = _interopRequireDefault(require("../../../components/ClickOutside"));
var _Separator = _interopRequireDefault(require("./Separator"));
var _styles = require("./styles");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const PopoverBodyItems = _react.default.memo(({
  items = []
}) => {
  const config = (0, _react.useContext)(_Context.ConfigContext);
  const handleLinkClick = link => () => {
    const {
      onClick,
      to
    } = link;
    if (onClick) {
      onClick(to);
    }
  };
  return items.map((link, index) => _react.default.createElement(_styles.PopoverItem, {
    key: index
  }, link.active ? _react.default.createElement(_styles.PopoverItemText, {
    title: link.children
  }, link.children) : _react.default.createElement(_styles.PopoverLink, {
    href: !link.onClick ? `${config.appPrefix}${link.to}` : null,
    title: link.children,
    onClick: handleLinkClick(link)
  }, link.children)));
});
const BreadcrumbsPopover = _react.default.memo(({
  items = [],
  renderSeparator = true
}) => {
  const [isOpen, setIsOpen] = (0, _react.useState)(false);
  const triggerPopover = () => {
    setIsOpen(!isOpen);
  };
  const closePopover = () => {
    setIsOpen(false);
  };
  const modifiers = (0, _modifiers.getModifiers)({
    closePopover
  });
  return _react.default.createElement(_reactPopper.Manager, null, _react.default.createElement(_reactPopper.Reference, null, ({
    ref
  }) => _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_styles.PopoverTrigger, {
    isOpen: isOpen,
    ref: ref,
    onClick: triggerPopover
  }, "..."), renderSeparator && _react.default.createElement(_Separator.default, null))), _react.default.createElement(_Portal.default, null, isOpen && _react.default.createElement(_ClickOutside.default, {
    onClickOutside: closePopover
  }, _react.default.createElement(_reactPopper.Popper, {
    strategy: "absolute",
    placement: "bottom",
    modifiers: modifiers
  }, ({
    ref,
    style,
    placement,
    arrowProps
  }) => _react.default.createElement(_styles.Popover, {
    ref: ref,
    style: style,
    "data-placement": placement
  }, _react.default.createElement(_styles.PopoverBody, null, _react.default.createElement(PopoverBodyItems, {
    items: items
  })), _react.default.createElement(_styles.Arrow, {
    ref: arrowProps.ref,
    style: arrowProps.style,
    "data-placement": placement
  }))))));
});
var _default = exports.default = BreadcrumbsPopover;